import { defineComponent as _defineComponent } from 'vue'
import { ref } from "./TUIKit/adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import router from "./router/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let locale = ref<string>("zh");
TUIStore.watch(StoreName.USER, {
  kickedOut: (value: string) => {
    if (value && router.currentRoute.name !== "login") {
      // localStorage.removeItem("TUIKit-userInfo");
      // router.replace({ name: "login" });
    }
  },
});
function changeLanguage(language: string) {
  locale.value = language;
}

return { __sfc: true,locale, changeLanguage }
}

})